
const CellNADisplay: React.FC<{ data: any, data_key: string }> = ({ data, data_key }) => {

    return (
        <span>{data[data_key] ? data[data_key] : "N/A"}</span>
    )

}

export default CellNADisplay;